import {Component, EventEmitter, Input, Output} from '@angular/core';
import {OrganizationTrophyItem} from "../../../interfaces/organization-trophy-item";
import {Overlayable} from "../../../interfaces/overlayable";

@Component({
  selector: 'brt-trophies-list',
  templateUrl: './trophies-list.component.html',
  styleUrls: ['./trophies-list.component.scss']
})
export class TrophiesListComponent implements Overlayable {

  items: OrganizationTrophyItem[] = [];

  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  @Input('items') set setItems(value: any) {
    if(value) {
      this.items = value;
    }
  }
}
